import { render, staticRenderFns } from "./AuctionGroup.vue?vue&type=template&id=8fdb32aa&scoped=true"
import script from "./AuctionGroup.vue?vue&type=script&lang=js"
export * from "./AuctionGroup.vue?vue&type=script&lang=js"
import style0 from "./AuctionGroup.vue?vue&type=style&index=0&id=8fdb32aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fdb32aa",
  null
  
)

export default component.exports